module.exports = __webpack_public_path__ + "img/moncash_mini.4c139eaa.png";